import { render } from "./color-picker.vue?vue&type=template&id=87e27d6e&lang=html"
import script from "./color-picker.vue?vue&type=script&lang=js"
export * from "./color-picker.vue?vue&type=script&lang=js"

import "./color-picker.vue?vue&type=style&index=0&id=87e27d6e&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__